module.exports = __webpack_public_path__ + "img/thumbnails-6-modal-menu-slider.7c51da27.png";